import { render, staticRenderFns } from "./GridBox.vue?vue&type=template&id=1f2db567&scoped=true"
import script from "./GridBox.vue?vue&type=script&lang=js"
export * from "./GridBox.vue?vue&type=script&lang=js"
import style0 from "./GridBox.vue?vue&type=style&index=0&id=1f2db567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2db567",
  null
  
)

export default component.exports